import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { DollarSign, FileText } from "lucide-react";

export const JobDetailCostSummary = ({
  job,
  isMechanic,
  canCreateInvoice,
  onCreateInvoice,
}) => {
  // Don't show for mechanics
  if (isMechanic) return null;

  const partsTotal = (job.parts_used || []).reduce(
    (sum, p) => sum + p.quantity * p.unit_price,
    0
  );
  const labourCharge = job.labour_charge || 0;
  const total = partsTotal + labourCharge;

  return (
    <Card className="border-slate-200 shadow-sm rounded-sm" data-testid="cost-summary-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-semibold text-slate-800 flex items-center gap-2">
          <DollarSign className="w-5 h-5" />
          Cost Summary
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex justify-between text-sm">
          <span className="text-slate-600">Labour</span>
          <span className="font-medium">${labourCharge.toFixed(2)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-slate-600">Parts</span>
          <span className="font-medium">${partsTotal.toFixed(2)}</span>
        </div>
        <div className="border-t pt-2 flex justify-between">
          <span className="font-semibold text-slate-800">Total</span>
          <span className="font-bold text-lg text-blue-600">${total.toFixed(2)}</span>
        </div>

        {canCreateInvoice && (
          <Button
            onClick={onCreateInvoice}
            className="w-full mt-4 bg-emerald-600 hover:bg-emerald-700 rounded-sm"
            data-testid="create-invoice-btn"
          >
            <FileText className="w-4 h-4 mr-2" />
            Create Invoice
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default JobDetailCostSummary;
